import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { GroundControlTypeDocument, groundControlTypesPullQueryBuilder } from './queryBuilder';

export function groundControlTypesFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<GroundControlTypeDocument> {
  const syncConfig = configBuilder<GroundControlTypeDocument>(
    RxdbCollectionNameV2.GROUND_CONTROL_TYPES,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, groundControlTypesPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy had GroundControlTypes pulling on LiveInterval.MINUTES_15
  return create(RxdbCollectionNameV2.GROUND_CONTROL_TYPES, replicationState, [sites]);
}
